var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelationship(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154473",
    "data-name": "Rectangle 154473",
    width: 25.629,
    height: 19.208,
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187484",
    "data-name": "Group 187484",
    transform: "translate(-325 -266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325 266)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187420",
    "data-name": "Group 187420",
    transform: "translate(332 277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187419",
    "data-name": "Group 187419",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37637",
    "data-name": "Path 37637",
    d: "M0,11.851a16.332,16.332,0,0,1,.4-1.644,6.2,6.2,0,0,1,3.04-3.5l.22-.116a11.589,11.589,0,0,1-.718-1.131A3.828,3.828,0,0,1,5.864.036,3.893,3.893,0,0,1,8.321.51a.431.431,0,0,1,.227.6.448.448,0,0,1-.607.162A5.456,5.456,0,0,0,6.865.9a2.813,2.813,0,0,0-2.91,1.244,2.8,2.8,0,0,0-.164,3.119A2.864,2.864,0,0,0,6.583,6.809a3.914,3.914,0,0,0,.592-.088c.3-.056.52.052.579.289a.437.437,0,0,1-.384.54A3.822,3.822,0,0,1,4.7,7.264a.522.522,0,0,0-.391,0A5.4,5.4,0,0,0,.865,12.2c-.046.755-.007,1.515-.007,2.291H4.735a8.157,8.157,0,0,1,4.7-6.511,4.736,4.736,0,0,1,.244-6.791,4.759,4.759,0,0,1,6.167-.08,4.741,4.741,0,0,1,.337,6.87,8.211,8.211,0,0,1,4.7,6.516h3.884c-.035-1.523.179-3.059-.537-4.5a5.489,5.489,0,0,0-2.918-2.741.537.537,0,0,0-.392.011,3.794,3.794,0,0,1-2.624.292c-.334-.08-.485-.259-.434-.526s.279-.373.609-.3a2.986,2.986,0,1,0-.575-5.57A3,3,0,0,1,17.6,1.3a.414.414,0,0,1-.533-.188.4.4,0,0,1,.169-.559,5.28,5.28,0,0,1,.985-.415,3.827,3.827,0,0,1,3.821,6.28c-.039.043-.074.088-.1.114.468.321.96.6,1.387.961A6.166,6.166,0,0,1,25.6,12.078c.046.923.015,1.851.013,2.776,0,.353-.163.5-.534.5q-1.926,0-3.852,0h-.312v.278q0,1.5,0,3c0,.426-.143.567-.573.567H5.286c-.446,0-.585-.137-.586-.579,0-1.075,0-2.15,0-3.268H4.4c-1.276,0-2.552-.005-3.827,0A.57.57,0,0,1,0,15.054v-3.2m20.023,6.493A35.927,35.927,0,0,0,20,14.633,7.03,7.03,0,0,0,15.6,8.67a.359.359,0,0,0-.367.023,5.186,5.186,0,0,1-.8.4,4.587,4.587,0,0,1-3.971-.346.514.514,0,0,0-.376-.082,7.037,7.037,0,0,0-4.5,6.231c-.093,1.126-.022,2.265-.025,3.4,0,.014.015.027.028.051ZM12.806,8.534a3.844,3.844,0,1,0-3.842-3.86,3.865,3.865,0,0,0,3.842,3.86",
    transform: "translate(0 0.001)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.84bfb4e62d48d3c53863f1cbb616bc92.svg";
export { ForwardRef as ReactComponent };